import { ObjectID } from 'bson';
import mongoose, { Schema } from 'mongoose';
import { longLat as longLatValidator } from '../common-validators';
import { TransportMode } from '../constants';
import mapRouteStepSchema, { IMapRouteStep } from './map-route-step';

type ICoordinates = [number, number];

export interface IMapDistanceCache {
  _id: ObjectID;
  startPoint: ICoordinates;
  endPoint: ICoordinates;
  transportMode: TransportMode;
  distanceInMeters: number;
  baseTimeInSeconds: number;
  trafficTimeInSeconds: number;
  steps?: IMapRouteStep[];
  updatedAt: Date;
  createdAt: Date;
}

export interface IMapDistanceCacheDocument extends mongoose.Document, IMapDistanceCache {
  _id: ObjectID;
}

const mapDistanceCache = new Schema(
  {
    startPoint: {
      type: [Number],
      required: true,
      validate: longLatValidator,
    },
    endPoint: {
      type: [Number],
      required: true,
      validate: longLatValidator,
    },
    transportMode: {
      type: String,
      required: true,
      enum: Object.values(TransportMode),
    },
    distanceInMeters: {
      type: Number,
      required: true,
    },
    baseTimeInSeconds: {
      type: Number,
      required: true,
    },
    trafficTimeInSeconds: {
      type: Number,
      required: true,
    },
    steps: {
      type: [mapRouteStepSchema],
      required(this: IMapDistanceCache | null) {
        if (!this) return false;
        if (this.transportMode === TransportMode.publicTransit) return true;
        return false;
      },
    },
  },
  { timestamps: true },
);

const thirtyDaysInSeconds = 2_592_000; // 30 days
mapDistanceCache.index({ updatedAt: 1 }, { expireAfterSeconds: thirtyDaysInSeconds });

export default mapDistanceCache;
